<template>
  <div class="org4" v-loading='loading'>
    <div class="trendchart">
      <PieRes-chart id="TrendChart" :chartData="chartData" height="1000px" width="100%"  style="-webkit-filter: saturate(0.5);filter: saturate(0.5);" />
    </div>
    <div style="margin-bottom: 50px;">
      <h3>学术趋势明细</h3>
      <el-table
        :data="tableTrendData"
        border
        default-expand-all
        style="width: 100%; margin-top: 20px">
        <el-table-column
          prop="name"
          width="200"
          align="center"
          label="年份">
        </el-table-column>
        <el-table-column
          prop="value"
          width="200"
          align="center"
          label="成果总量">
        </el-table-column>
        <el-table-column
          label="研究方向">
          <template slot-scope="scope">

            <span v-for="(item,index) in scope.row.topKeywords.buckets" :key='index'>{{item.name}}({{item.value}}) </span>
          </template>

        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import Common from '@/components/commonOrg/Common'
import WordcloudChart from '@/components/Charts/WordcloudChart'
import PieResChart from '@/components/Charts/PieResChart'
import { getTrend } from '@/api/organization'

export default {
  name: 'Overview',
  props: {
    allData: Object
  },
  atch: {
    allData: {
      deep: true,
      handler (val) {
        this.trendFun()
      }
    }
  },
  components: {
    Common,
    PieResChart,
    WordcloudChart
  },
  data () {
    return {
      tableTrendData: [],
      chartData: [],
      loading: false
    }
  },
  methods: {
    trendFun () {
      const data = {
        name: [this.allData.name]
      }
      getTrend(data).then(res => {
        // console.log(res)
        this.loading = false
        this.chartData = res.data.tops.topYears.sort((a, b) => {
          return b.name - a.name
        }).slice(1, 10)

        this.chartData.forEach((item, index) => {
          if (item.name) {

          }
        })
        this.tableTrendData = this.chartData
      })
    }
  },
  mounted () {
    this.loading = true
    console.log(this.allData)
    if (Object.keys(this.allData).length) {
      this.trendFun()
    }
  }
}
</script>

<style lang="scss">
.org4{
  .trend-container{
    margin: 50px 0;
    .trend-l{
      float: left;
      width: 55%;
      h3{
        margin-bottom: 20px;
      }
    }
    .trend-r{
      float: right;
      width: 40%;
      h3{
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/organization/Orgs/org4.vue